module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }), _vm._v(" "), (this.userLoaded) ? _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "min-height": "400px",
      "background": "#F0F0ED",
      "border": "color: white",
      "border-width": "5%"
    }
  }, [_c('div', {
    staticClass: "movie-card"
  }, [_c('div', {
    staticClass: "container-movie"
  }, [(!this.mobileAndTabletCheck()) ? _c('div', [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "details-profile"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "9%"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticStyle: {
      "background": "black",
      "width": "75px",
      "border-radius": "50%",
      "border": "4px solid #FFF"
    },
    attrs: {
      "alt": "cover",
      "src": "static/img/REKFIXLOGOSMALL.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-8"
  }, [_c('div', {
    staticClass: "float-left"
  }, [_c('h1', {
    staticStyle: {
      "font-size": "3vw",
      "background": "black",
      "color": "white",
      "padding-top": "-5%",
      "display": "inline-block",
      "text-align": "center",
      "padding": "0em 0.2em 0em 0.2em"
    }
  }, [_c('strong', [_vm._v(_vm._s(this.user.firstName) + " " + _vm._s(this.user.lastName))])])])])])])])]) : _c('div', [_c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "details-profile"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-left": "3%",
      "margin-top": "39%"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticStyle: {
      "background": "black",
      "width": "75px",
      "border-radius": "50%",
      "border": "4px solid #FFF"
    },
    attrs: {
      "alt": "cover",
      "src": "static/img/REKFIXLOGOLARGE.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-8"
  }, [_c('div', {
    staticClass: "float-left"
  }, [_c('h1', {
    staticStyle: {
      "font-size": "5vw",
      "background": "black",
      "color": "white",
      "padding-top": "-5%",
      "display": "inline-block",
      "text-align": "center",
      "padding": "0em 0.2em 0em 0.2em"
    }
  }, [_c('strong', [_vm._v(_vm._s(this.user.firstName) + " " + _vm._s(this.user.lastName))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "description-profile "
  }, [_c('div', {
    staticClass: "column2",
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4 emphasis"
  }, [_c('h2', {
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.9)"
    }
  }, [_c('strong', [_vm._v("Update Profile")])]), _vm._v(" "), _c('p', [_c('small', [_vm._v("Update User Profile")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info ",
    on: {
      "click": _vm.handleUpdate
    }
  }, [_c('span', {
    staticClass: "fa fa-user"
  }), _vm._v("  Update Profile")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 emphasis"
  }, [_c('h2', [_c('strong', {
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.9)"
    }
  }, [_vm._v("Auto Insurance")])]), _vm._v(" "), _c('p', [_c('small', [_vm._v("Policy Information")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/policies/PolicyList"
    }
  }, [_c('button', {
    staticClass: "btn btn-success "
  }, [_c('span', {
    staticClass: "fa fa-eye"
  }), _vm._v("  View Insurance Policies")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column1 text-center",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 profile-name"
  }, [_c('hr'), _vm._v(" "), _c('h2', {
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.9)"
    }
  }, [_c('strong', [_vm._v("User Information")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('dl', {
    staticClass: "dl-horizontal-profile"
  }, [_c('dt', [_vm._v("First Name")]), _c('dd', [_vm._v(_vm._s(this.user.firstName))]), _vm._v(" "), _c('dt', [_vm._v("Last Name")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(this.user.lastName))]), _vm._v(" "), _c('dt', [_vm._v("Email")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(this.user.email))]), _vm._v(" "), _c('dt', [_vm._v("Phone")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(this.user.phone))]), _vm._v(" "), _c('dt', [_vm._v("Zipcode")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(this.user.zipcode))]), _vm._v(" "), _c('dt', [_vm._v("City")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(this.user.city))]), _vm._v(" "), _c('dt', [_vm._v("State")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(this.user.state))])])])])])])])])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-744f4567!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/userProfile.vue
// module id = 1308
// module chunks = 2